<template>
  <div class="forbidden-error">
    <h1>403</h1>
    <p>このページへのアクセス権限がありません。</p>
    <el-button type="primary" @click="router.push('/top')">
      トップへ戻る
    </el-button>
  </div>
</template>

<script setup lang="ts">
  import router from '@/router';
</script>

<style scoped lang="scss">
  .forbidden-error {
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    text-align: center;
  }

  h1 {
    margin: 0;
    font-size: 64px;
    color: #606266;
  }

  p {
    margin: 0;
    color: #909399;
  }
</style>
